import script from "./area-picker.vue?vue&type=script&setup=true&lang=ts"
export * from "./area-picker.vue?vue&type=script&setup=true&lang=ts"

import "./area-picker.vue?vue&type=style&index=0&id=293844e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-293844e7"]])

export default __exports__